import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-container-storage",
  "use": "app-icon-container-storage-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-container-storage\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M6.08 12.133l4.331 2.5v5l-4.33 2.501-4.331-2.5v-5.001l4.33-2.5zm11.734 0l4.33 2.5v5l-4.33 2.501-4.33-2.5v-5.001l4.33-2.5zM11.947 1.866l4.331 2.5v5.001l-4.33 2.5-4.331-2.5v-5l4.33-2.501z\" stroke=\"#6C7280\" stroke-width=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol